import * as SagasType from '../constants/constant_saga_types';

export function csvReducer(state={}, action) {
  switch (action.type) {
    case SagasType.CSV_IMPORT_START_INPROGRESS: {
      const { id } = action;
      return { id, isStarting: true };
    }
    case SagasType.CSV_IMPORT_START_DONE: {
      const { id } = action;
      return { id, isStarted: true };
    }
    case SagasType.CSV_IMPORT_START_ERROR: {
      const { id, error } = action;
      return { id, error };
    }
    default: {
      return state;
    }
  }
}